
import { Component, ElementRef, EventEmitter, Input, Output } from '@angular/core';
import {SlideshowService} from './../../slideshow.service';
import { Utils } from '../../../utils';

@Component({
    selector: 'embed-content',
    templateUrl: 'embed.component.html'
})
export class PreviewEmbedComponent {
    private _embed = '';

    @Input('embed')
    set embed(embed) {
        this._embed = embed;
    }
    get embed() {
        return this._embed;
    }

    constructor(
        public slideshow: SlideshowService,
        public utils: Utils
    ) {}
}